export const AP_KNOWLEDGE_CENTER_ARTICLE_LOADER = {
  desktop: `<div class="cui cui-grid cui-container">
  <div class="cui-row">
    <div class="cui-col-xl-8 col-offset-xl-2 cui-col-lg-10 col-offset-lg-1">
      <div class="cui-skeleton-paragraph -spacing--bottom-40 -spacing--top-40">
        <div class="cui-skeleton-paragraph__content" style="width: 188px;">
          <div class="cui-skeleton__item" style="height: 16px;"></div>
        </div>
      </div>
      <div class="cui-skeleton-heading -size--large -spacing--top-24 -spacing--bottom-20 -resolution--desktop">
        <div class="cui-skeleton-heading__content" style="width: 100%;">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-skeleton-paragraph__content -spacing--top-24" style="width: 188px;">
        <div class="cui-skeleton__item" style="height: 16px;"></div>
      </div>
      <div class="-spacing--top-40">
        <div style="display: flex;">
          <span style="width: 100%; align-items: center; display: flex;">
            <span style="width: 100%; max-width: 188px;">
              <span class="cui-skeleton__item" style="height: 16px; display: flex;"></span>
            </span>
          </span>
          <div class="cui-skeleton-circle">
            <div class="cui-skeleton__item cui-skeleton-circle" style="width: 48px; height: 48px; margin-right: 16px"></div>
          </div>
          <div class="cui-skeleton-circle">
            <div class="cui-skeleton__item cui-skeleton-circle" style="width: 48px; height: 48px; margin-right: 16px"></div>
          </div>
          <div class="cui-skeleton-circle">
            <div class="cui-skeleton__item cui-skeleton-circle" style="width: 48px; height: 48px; margin-right: 16px"></div>
          </div>
          <div class="cui-skeleton-circle">
            <div class="cui-skeleton__item cui-skeleton-circle" style="width: 48px; height: 48px;"></div>
          </div>
        </div>
      </div>
      <div class="cui-skeleton-paragraph -size--large -resolution--desktop -spacing--top-64">
        <div class="cui-skeleton-paragraph__content" style="width: 100%;">
            <div class="cui-skeleton__item cui-skeleton__description"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-skeleton-paragraph -size--large -resolution--desktop -spacing--top-64">
        <div class="cui-skeleton-paragraph__content" style="width: 100%;">
          <div class="cui-skeleton__item cui-skeleton__description" style="width: 100%; max-width: 300px; height: 24px;"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-skeleton-paragraph -size--large -resolution--desktop -spacing--top-64">
        <div class="cui-skeleton-paragraph__content" style="width: 100%;">
          <div class="cui-skeleton__item cui-skeleton__description" style="width: 100%; max-width: 300px; height: 24px;"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-skeleton-paragraph -size--large -resolution--desktop -spacing--top-64 -spacing--bottom-64">
        <div class="cui-skeleton-paragraph__content" style="width: 100%;">
          <div class="cui-skeleton__item cui-skeleton__description" style="width: 100%; max-width: 300px; height: 24px;"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="cui-skeleton-heading -size--medium -spacing--top-64 -spacing--bottom-40 -resolution--desktop">
    <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
    </div>
  </div>
  <div class="cui-row">
    <div class="cui-col-lg-4">
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 390px;"></div>
      </div>
    </div>
    <div class="cui-col-lg-4">
      <div class="cui-skeleton-heading -size--medium -resolution--desktop">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 390px;"></div>
        </div>
      </div>
    </div>
    <div class="cui-col-lg-4">
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 390px;"></div>
      </div>
    </div>
  </div>
</div>`
};
